import { Component } from '@angular/core';

@Component({
  selector: 'app-pda-section-nodata',
  templateUrl: './pda-section-nodata.component.html',
  styleUrls: ['./pda-section-nodata.component.css']
})
export class PdaSectionNodataComponent {

}
